<template>
  <div class="app-container goods-sku-page">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="商品/SKU/规格/编码"
        style="width: 260px"
        class="filter-item"
        clearable
        @keyup.enter.native="handleFilter"
      />
      <el-select
        v-model="listQuery.isEnabled"
        placeholder="是否启用"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="启用" :value="1" />
        <el-option label="停用" :value="0" />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" icon="el-icon-refresh" @click="resetFilter">重置</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" size="small" border fit highlight-current-row>
      <el-table-column label="SKU ID" prop="skuId" align="center" width="90" />
      <el-table-column label="图片" align="center" width="90">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.skuImage || scope.row.goodsImage"
            class="sku-image"
            :src="scope.row.skuImage || scope.row.goodsImage"
            fit="cover"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="商品" min-width="220">
        <template slot-scope="scope">
          <div class="goods-name">{{ scope.row.goodsName || "-" }}</div>
          <div class="sub-text">商品ID：{{ scope.row.goodsId }}</div>
        </template>
      </el-table-column>
      <el-table-column label="SKU条目" min-width="220">
        <template slot-scope="scope">
          <div class="sku-name">{{ scope.row.skuName || scope.row.combNames || "默认SKU" }}</div>
          <div class="sub-text">{{ formatSpec(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="销售价" prop="price" align="center" width="110">
        <template slot-scope="scope">￥{{ money(scope.row.price) }}</template>
      </el-table-column>
      <el-table-column label="供货价" prop="supplyPrice" align="center" width="110">
        <template slot-scope="scope">￥{{ money(scope.row.supplyPrice) }}</template>
      </el-table-column>
      <el-table-column label="划线价" prop="originalPrice" align="center" width="110">
        <template slot-scope="scope">￥{{ money(scope.row.originalPrice) }}</template>
      </el-table-column>
      <el-table-column label="库存" prop="stock" align="center" width="100" />
      <el-table-column label="编码" align="center" min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.code || "-" }}</div>
          <div class="sub-text">{{ scope.row.mchNo || "" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="isEnabled" align="center" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isEnabled ? 'success' : 'info'">
            {{ scope.row.isEnabled ? "启用" : "停用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" prop="mddate" align="center" width="170">
        <template slot-scope="scope">{{ formatApiDate(scope.row.mddate) }}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="110" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="editGoods(scope.row)">编辑商品</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getGoodsSkuList } from "@/api/product";
import { formatApiDate } from "@/utils/utils";

export default {
  name: "GoodsSkuManagement",
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: "",
        isEnabled: null
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    formatApiDate,
    getList() {
      this.listLoading = true;
      getGoodsSkuList(this.listQuery)
        .then(response => {
          const data = response.data || {};
          this.list = data.entitys || [];
          this.total = data.totalCount || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter() {
      this.listQuery = {
        page: 1,
        pageSize: 20,
        keyword: "",
        isEnabled: null
      };
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.listQuery.pageSize = pageSize;
      this.getList();
    },
    handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    money(value) {
      const num = Number(value || 0);
      return num.toFixed(2);
    },
    formatSpec(row) {
      if (row.combNames) {
        return row.combNames;
      }
      if (!row.specValuePath) {
        return row.specMode === 0 ? "单规格" : "-";
      }
      try {
        const parsed = JSON.parse(row.specValuePath);
        if (parsed.legacyName) {
          return parsed.legacyName || "单规格";
        }
        return Object.keys(parsed)
          .map(key => `${key}：${parsed[key]}`)
          .join(" / ");
      } catch (e) {
        return row.specValuePath;
      }
    },
    editGoods(row) {
      this.$router.push({ path: "/product/list/edit/" + row.goodsId });
    }
  }
};
</script>

<style scoped lang="scss">
.goods-sku-page {
  .sku-image {
    width: 48px;
    height: 48px;
    border-radius: 6px;
  }

  .goods-name,
  .sku-name {
    color: #303133;
    font-weight: 600;
    line-height: 22px;
  }

  .sub-text {
    color: #909399;
    font-size: 12px;
    line-height: 20px;
  }
}
</style>
